module.exports = __webpack_public_path__ + "img/Logo-Multi-Branco.da7cad93.png";